import { h } from 'preact';

import SectionTitle from '../../../components/2-atoms/section-title/section-title';
import { LatestNewsWrapper, LatestNewsBody, LatestNewsTop } from '../latest-news-wrapper';
import LatestNewsSkeleton from '../latest-news-skeleton';

export function renderLatestNewsSkeleton({ widget, htmlProps, isRail }) {
  const modifiers = ['border'];

  return (
    <LatestNewsWrapper isRail={isRail}>
      {isRail && (
        <LatestNewsTop>
          <SectionTitle modifiers={modifiers}>{htmlProps.widgetTitle}</SectionTitle>
        </LatestNewsTop>
      )}
      <LatestNewsBody isRail={isRail}>
        <LatestNewsSkeleton
          skeletonColor={widget.styles.skeletonColor}
          setsOfCardsModifiers={widget.styles.setsOfCardsModifiers[htmlProps.position]}
          cardModifiers={widget.styles.cardModifiers[htmlProps.position]}
          maxContents={htmlProps.cards}
        />
      </LatestNewsBody>
    </LatestNewsWrapper>
  );
}
